var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"candidate"},[_c('candidateHeader',{attrs:{"showSetup":_vm.showSetup}}),_c('router-view'),_c('setupModal',{attrs:{"show":_vm.showSetup},on:{"close":_vm.skipSetup}}),_c('password-change-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }